import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("rounded-md animate-shimmer", className)}
      {...props}
    />
  );
}

export { Skeleton };
